export default {
  getRolesEmployees(state, getters) {
    return state.rolesEmployees.filter(item => item.employees.length);
  }
}